import { useNavigate } from "react-router-dom";
import logo from "../../assets/images/icon_512.png";

/**
 * @description Header component. Contains the Logo, Title, and Slogan.
 */
export default function Header() {
  const navigate = useNavigate();

  return (
    <div
      onClick={() => {
        navigate("/");
      }}
      className="self-start select-none cursor-pointer inline-flex flex-row ~pt-4/5.5 ~px-3.5/5 origin-top-left hover:scale-105 duration-250"
    >
      <img src={logo} className="~w-12/16 ~pr-1.5/2 z-10" alt="logo"></img>
      <div className="flex flex-col" data-aos="fade-down">
        <span className="text-silver font-barlowc font-black ~text-xl/xxl leading-4 ~pt-1/1.5">
          BITMILLIONS
        </span>
        <span className="text-gray font-archb ~text-xs/sm ~pt-1/1.5">
          Play for the prize, stay for the cause
        </span>
      </div>
    </div>
  );
}
